var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.baseChartData)?_c('div',{staticClass:"row",staticStyle:{"height":"100%"}},[_c('div',{ref:"lineChart",staticClass:"col-9",staticStyle:{"width":"75%","height":"100%"}}),_c('div',{ref:"pieChart",staticClass:"col-3",staticStyle:{"width":"25%","height":"100%"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }